const PRESET_TYPES = {
  SEARCH: 'search',
  EXPORT: 'export',
  COLUMN: 'column',
};

export default PRESET_TYPES;
